import script from "./Transfer1.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transfer1.vue?vue&type=script&setup=true&lang=ts"

import "./Transfer1.vue?vue&type=style&index=0&id=85a576c6&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85a576c6"]])

export default __exports__